import Component from './component';

export interface Props {
	routes: Route[];
}

interface Route {
	name: string;
	path: string;
}

Component.defaultProps = {
};
export default Component;
